export default __webpack_public_path__ + "static/media/companyIcon.328e6898.svg";